import { defineMessages } from "react-intl";
const messages = defineMessages({
    sgtTitle: {
        id: "app.sgt.sgtTitle.text",
        defaultMessage: "Self-Guided Tours",
    },
    bannerTitle: {
        id: "app.sgt.banner.title.text",
        defaultMessage: "Ready to automate in-person tours?",
    },
    bannerDescription: {
        id: "app.sgt.banner.description.text",
        defaultMessage: "Self-Guided Tours create a frictionless online to onsite experience that requires little to no interaction from your team. To access this feature, contact sales to upgrade your plan.",
    },
    bannerItem1: {
        id: "app.sgt.banner.item1.text",
        defaultMessage: "Do less by allowing prospects to self-serve online & on-site",
    },
    bannerItem2: {
        id: "app.sgt.banner.item2.text",
        defaultMessage: "Minimize no-shows by providing a flexible tour schedule.",
    },
    bannerItem3: {
        id: "app.sgt.banner.item3.text",
        defaultMessage: "Reduce on-site staff training and labor costs.",
    },
    searchCommunity: {
        id: "app.sgt.search.text",
        defaultMessage: "Search for a community",
    },
});
export default messages;
